import { Configuration2D } from '../../../configuration2d';
import { Location } from '../../../location';
import { Resume } from '../../../resume/resume';
import { DrawerLocations } from '../../closet-doors-standard/drawer-locations';
import { DoorRange } from '../door-range';
import { DoorStructure } from '../door-structure';
import { Frame } from '../frame';
import { OpeningSystem } from '../opening-system';
import { OpeningSystemSide } from '../opening-system-side';
import { Supplier } from '../supplier';
import { FrameFinish } from '../frame-finish';
import { ConfigurationAccessory } from './configuration-accessory';
import { ConfigurationDoorStructure } from './configuration-door-structure';
import { AccessoryCategory } from '../accessory-category';

export class Configuration extends Configuration2D {
  location: Location;
  locationId?: number;
  hasDrawers: boolean = false;
  drawerLocations: DrawerLocations;

  clientHeight?: number;
  clientWidth?: number;
  clientHasBaseboard?: boolean = false;
  baseboardQty?: number;
  baseboardThickness?: number;
  percentageOpening?: number;
  openingSystem: OpeningSystem;
  openingSystemId?: number;
  openingSystemSide: OpeningSystemSide;
  openingSystemSideId?: number;
  nbDoor: number;
  nbWay: number;

  supplier: Supplier;
  supplierId?: number;
  doorRange: DoorRange;
  doorRangeId?: number;

  configurationDoorStructures: ConfigurationDoorStructure[];
  // Refactor door structure
  doorStructure: DoorStructure;
  frame: Frame;
  frameId?: number;
  frameFinish: FrameFinish;
  frameFinishId?: number;

  configurationAccessories: ConfigurationAccessory[] = [];

  /** Liste des types d'accessoires requis pour la configuration */
  requiredAccessoryTypes: AccessoryCategory[];

  isComplete: boolean;

  resume: Resume;

  // Force le passage sur la page des accessoires pour purger les accessoires non compatibles
  checkAccessories: boolean = true;

  hasValidQuotation: boolean;
}
